export default defineComponent({
  name: 'ItemTripleTextImage',
  props: {
    firstText: String,
    image: Object,
    secondText: String,
    thirdText: String
  }
});